import { Collapse, Modal } from 'bootstrap'
import slideout from 'slideout'
import AOS from 'aos'
  import 'aos/dist/aos.css'

/**
 * Position the main nav dropdowns.
 */
function positionMainNavLinkDropdowns() {
  const navLinks = document.querySelectorAll('#menu-main-menu > .nav-item')
  navLinks.forEach(navLink => {
    const navLinkCoords = navLink.getBoundingClientRect()
    const dropdown = navLink.querySelector('ul.sub-menu')

    if (dropdown) {
      dropdown.style.left = (navLinkCoords.right - dropdown.clientWidth - 24) + 'px'
    }
  })
}

// On load
positionMainNavLinkDropdowns()

// On window resize
window.addEventListener('resize', () => {
  positionMainNavLinkDropdowns()
})

/**
 * Add a CSS class to the header on scroll.
 */
window.addEventListener('scroll', () => {
  const scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
  const body = document.querySelector('body')

  let scrollTrigger = document.querySelector('.app-header').clientHeight

  if (scrollTop >= scrollTrigger) {
    body.classList.add('scrolled')
  } else {
    body.classList.remove('scrolled')
  }
})

/**
 * Scroll to element.
 */
const scrollToElements = document.querySelectorAll('[data-scroll-to]')
for (const scrollToElement of scrollToElements) {
  scrollToElement.addEventListener('click', e => {
    e.preventDefault()

    const selector = e.target.dataset.scrollTo
    const offsetTop = document.querySelector(selector).offsetTop

    scroll({
      top: offsetTop,
      behavior: 'smooth',
    })
  })
}

/**
 * Slideout Nav.
 * @see https://github.com/mango/slideout
 */
const slideoutNav = new slideout({
  panel: document.getElementById('app-panel'),
  menu: document.getElementById('app-nav-mobile'),
  padding: 320,
  tolerance: 70,
  side: 'right',
  touch: false,
})

document.querySelector('.nav-icon').addEventListener('click', () => {
  slideoutNav.toggle()
})

document.querySelector('#app-nav-mobile .btn-close').addEventListener('click', () => {
  slideoutNav.close()
})

// Sub-menus
document.querySelectorAll('#app-nav-mobile .nav-link').forEach(link => {
  link.addEventListener('click', (e) => {
    if (e.target.getAttribute('href') == '#') {
      var btn = e.target.nextElementSibling
      var myCollapse = document.querySelector(btn.getAttribute('data-bs-target'))
      var bsCollapse = new Collapse(myCollapse, {
        toggle: true,
      })
    }
  })
})

/**
 * Modals.
 *
 * Appends the Bootstrap modal backdrop to the app panel
 * so that it is under the modal itself.
 */
const modals = document.querySelectorAll('.modal')
modals.forEach(modal => {
  modal.addEventListener('show.bs.modal', e => {

    // Backdrop
    const backdrop = document.createElement('div')
    backdrop.classList.add('modal-backdrop', 'fade', 'show')
    document.querySelector('#app-panel').appendChild(backdrop)

    // Button that triggered the modal.
    const button = e.relatedTarget
    if (button) {

      // For products, insert additional data in the hidden form fields,
      // and set the breadcrumbs.
      const product = button.getAttribute('data-product')
      if (product) {
        let breadcrumbs = []
        const industry = button.getAttribute('data-industry')
        const category = button.getAttribute('data-category')

        const industryInput = modal.querySelector('.industry-input input[type="hidden"]')
        const categoryInput = modal.querySelector('.category-input input[type="hidden"]')
        const productInput = modal.querySelector('.product-input input[type="hidden"]')

        if (industryInput && industry) {
          industryInput.value = industry
          breadcrumbs.push(industry)
        } else {
          console.warn('.industry-input class not set on product inquiry form input.')
        }

        if (categoryInput && category) {
          categoryInput.value = category
          breadcrumbs.push(category)
        } else {
          console.warn('.category-input class not set on product inquiry form input.')
        }

        if (productInput) {
          productInput.value = product
          breadcrumbs.push(product)
        } else {
          console.warn('.product-input class not set on product inquiry form input.')
        }

        // Breadcrumbs
        modal.querySelector('.breadcrumbs').innerHTML = breadcrumbs.join(' &gt; ')
      }
    }
  })

  modal.addEventListener('hidden.bs.modal', e => {
    const backdrop = document.querySelector('.modal-backdrop')
    backdrop.parentNode.removeChild(backdrop)
  })
})

// Look for links that target modals...
const modalLinks = document.querySelectorAll('a[href^="#"]')
modalLinks.forEach(modalLink => {
  modalLink.addEventListener('click', (e) => {
    e.preventDefault()

    const href = modalLink.getAttribute('href')
    if (href && href != '#' && href != '#/') {

      const target = document.querySelector(href)
      if (target && target.classList.contains('modal')) {
        const modal = Modal.getOrCreateInstance(target)
        modal.show()
      }
    }
  })
})

/**
 * AOS.js.
 * Animate elements as they are scrolled into view.
 *
 * https://github.com/michalsnik/aos
 */
new AOS.init()
